import { css } from 'emotion';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';

export namespace styles {
  export const container = css({});

  export const labelContainer = css({
    marginBottom: '8px'
  });

  export const labelInner = css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'none',
    borderStyle: 'none',
    cursor: 'pointer',
    padding: '0',
    font: 'inherit',
    outline: 'inherit',
    width: '100%',
    fontWeight: 500,
    '@media(min-width: 678px)': {
      display: 'inline-block',
      width: 'auto'
    }
  });

  export const label = css({
    marginRight: '16px'
  });

  export const valueContainer = css({
    minHeight: 20,
    color: '#888888',
    ...getInterUIDynamicMetricCssObject(14),
    maxWidth: '80%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginTop: 16
  });

  export const chevron = (open: boolean) =>
    css({
      height: 12,
      width: 12,
      transform: open ? 'rotate(180deg)' : undefined,
      transition: animationTransition('transform')
    });
}
